<div class="container">
    <div class="title">{{data.title |translate}}</div> <br />
    <div class="body">{{data.label0 |translate }} </div><br />
    <div class="subtitle">{{data.subtitle1 |translate }}</div><br />
    <div class="body">{{data.label1 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle2 |translate }} </div><br />
    <div class="body">{{data.label2 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle3 |translate }} </div><br />
    <div class="body">{{data.label3 |translate }}</div> <br />
    <div class="subtitle">{{data.subtitle4 |translate }} </div><br />
    <div class="body">{{data.label4a |translate }}</div> <a href="mailto:mesdonneespersonnelles.laposte@laposte.fr" class="body">{{data.label4aMailTo |translate }}</a> <span class="body">{{data.label4aBis |translate }}</span>
    <br />
</div>
<div class="button-bar">
    <div class="button" (click)="onNoClick()">retour</div>
</div>